
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5db55dad&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Materials.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Materials.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5db55dad!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Materials.vue"),
  /* scopeId */
  "data-v-5db55dad",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Materials.vue
// module id = 850
// module chunks = 2